var _ellipse, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnboarding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20,
    cy: 15,
    rx: 5,
    ry: 5,
    fill: "url(#paint0_linear_623_3429)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.999 21.6671C24.0276 21.6671 27.499 23.6526 29.0829 26.5132C29.179 26.6866 29.1296 26.9028 28.9708 27.0215C26.4688 28.8918 23.364 30 20 30.0001C16.6358 30.0001 13.5303 28.8919 11.0282 27.0215C10.8694 26.9028 10.8201 26.6866 10.9161 26.5132C12.4999 23.6527 15.9706 21.6672 19.999 21.6671Z",
    fill: "url(#paint1_linear_623_3429)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4124 6.68542H29.2514C31.276 6.68542 32.2883 6.68542 33.0643 7.07318C33.7766 7.42908 34.3541 8.00658 34.71 8.71885C35.0977 9.49487 35.0977 10.5072 35.0977 12.5318V13.3708M28.4124 33.4268H29.2514C31.276 33.4268 32.2883 33.4268 33.0643 33.039C33.7766 32.6831 34.3541 32.1056 34.71 31.3934C35.0977 30.6174 35.0977 29.6051 35.0977 27.5805V26.7415M11.699 6.68542H10.86C8.83541 6.68542 7.82311 6.68542 7.0471 7.07318C6.33482 7.42908 5.75733 8.00658 5.40142 8.71885C5.01367 9.49487 5.01367 10.5072 5.01367 12.5318V13.3708M11.699 33.4268H10.86C8.83541 33.4268 7.82311 33.4268 7.0471 33.039C6.33482 32.6831 5.75733 32.1056 5.40142 31.3934C5.01367 30.6174 5.01367 29.6051 5.01367 27.5805V26.7415",
    stroke: "url(#paint2_linear_623_3429)",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_623_3429",
    x1: 15,
    y1: 15,
    x2: 25,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C64DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_623_3429",
    x1: 10.8672,
    y1: 25.8336,
    x2: 29.132,
    y2: 25.8336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C64DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_623_3429",
    x1: 5.01367,
    y1: 20.0561,
    x2: 35.0977,
    y2: 20.0561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C64DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F31"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboarding);
export default __webpack_public_path__ + "static/media/onboarding.3fad3496409daf1618c2ac1e68a1a777.svg";
export { ForwardRef as ReactComponent };